<template>
    <div class="company-Main">
        <p class="current">当前位置：<span>视频详情</span></p>
        <div class="company-info">
            <p class="companyName">{{ companyInfo.name }} </p>
            <p class="video-create">发布时间：<span>{{ companyInfo.create_time }}</span></p>
            <p class="video-publisher" style="font-size: 16px;color: #666;text-align: left;padding-bottom: 10px;border-bottom: 0.5px solid #f2f2f2;">发布者：{{ companyInfo.author }}</p>
            <videoPlayer :mp4Url="companyInfo.file_url" :mp4Pic="companyInfo.firstFile.FileUrl" style="margin-top: 20px"></videoPlayer>

           
            <div class="company-detail">
                <el-collapse v-model="activeNames" @change="handleChange">
                    <el-collapse-item title="详细介绍" name="1">
                        <div v-html="companyInfo.intro" class="introinfo"></div>
                    </el-collapse-item>
                    
                </el-collapse>
            </div>
          
        </div>
    </div>
</template>
<script>
import videoPlayer from './videoPlayer.vue'
export default({
    data(){
        return {
            companyInfo: [],
            activeNames: ['1'],
            companyproduct: []
        }
    },
    components:{
        videoPlayer
    },
    methods: {
        handleChange(val) {
            console.log(val);
        },
        getTimeDate(timeDate){
            const year = timeDate.getFullYear();
                const month = (timeDate.getMonth() + 1).toString().padStart(2, '0');
                const day = timeDate.getDate().toString().padStart(2, '0');
                const hours = timeDate.getHours().toString().padStart(2, '0');
                const minutes = timeDate.getMinutes().toString().padStart(2, '0');
                const seconds = timeDate.getSeconds().toString().padStart(2, '0');
                const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

                return formattedDate
        },
    },
    mounted(){
        let data = {
            id: this.$route.query.key
        }
        console.log("第一步");
        this.$store.dispatch('video/videoinfo',data)
            .then(res => {
                if(res.ok){
                    this.companyInfo = res.data
                    console.log(this.companyInfo);
                    const timeDate = new Date(this.companyInfo.create_time)
                    this.companyInfo.create_time = this.getTimeDate(timeDate)
                }
            })
        
    }
})
</script>

<style scoped>
@import url(../../css/collapse.css);
.video-create{
    margin-top: 20px;
    font-size: 16px;
    color: #666666;
    text-align: left;    
}
.video-create span{
    color: #4095e5;
}
@import url(../../css/collapse540.css);
</style>
